import React from 'react';
// import PropTypes from 'prop-types';
import { Route, Switch, useRouteMatch, useHistory } from 'react-router-dom';
import InvoiceTable from '../components/InvoiceTable';
import SelectedInvoice from '../components/SelectedInvoice';

function InvoiceRoutes() {
  const match = useRouteMatch();
  const history = useHistory();
  const handleBack = () => {
    history.push(match.url);
  };
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={InvoiceTable} />
      <Route path={`${match.path}/:id`}>
        <SelectedInvoice onGoBack={handleBack} />
      </Route>
    </Switch>
  );
}

InvoiceRoutes.propTypes = {};

export default InvoiceRoutes;
